import {Inject, Injectable} from '@angular/core';
import {datadogLogs as datadog} from '@datadog/browser-logs';
import {LoggerService} from './logger.service';
import {ENVIRONMENT, EnvironmentShared} from '@emma-labs/shared/typescript';

@Injectable({
  providedIn: 'root',
})
export class DatadogLoggerService implements LoggerService {
  constructor(@Inject(ENVIRONMENT) private readonly environment: EnvironmentShared) {
    this.initDatadog();
  }

  warn(message: string, context?: {[x: string]: any}): void {
    datadog.logger.warn(message, context);
  }

  error(message: string, context?: {[x: string]: any}): void {
    datadog.logger.error(message, context);
  }

  private initDatadog() {
    if (!this.environment.datadogLogsClientToken) {
      throw new Error('Datadog client token is missing');
    }

    datadog.init({
      clientToken: this.environment.datadogLogsClientToken,
      env: this.environment.environment,
      site: 'datadoghq.com',
      forwardErrorsToLogs: false,
      sessionSampleRate: 100,
    });
  }
}
